import { Component, Input, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { IUser } from 'src/app/core/models';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent implements OnInit {
  greetingLanguageLabel: string="Hello";
  constructor(private userService: UserService) { }
  ngOnInit() {  
  }
  public get userObject(): IUser {
    return this.userService.readUserObject;
  }
}
